var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('spinner',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoad),expression:"!isLoad"}],attrs:{"over":""}}),_c(_vm.currentStepComponent,{tag:"component",on:{"root-load":_vm.rootLoadHandler}}),_c('modals-container'),(_vm.isDevelopMode)?_c('debug-panel'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }